import React, { FunctionComponent, memo, useState } from 'react';
import ReactDom from 'react-dom';
import { useEffectOnce } from 'usehooks-ts';

import Filter from 'components/Filter/Filter';
import ViewChanger from 'components/ViewChanger/ViewChanger';
import { WorkPageDataCMS } from 'containers/WorkPage/WorkPage.types';

import * as S from './Controller.styles';

export interface ControllerProps {
  filterText: string;
  filterTagsList: WorkPageDataCMS['filterPopup'];
  viewChanger?: boolean;
}

const defaultProps: Partial<ControllerProps> = {
  filterText: 'Show me:',
  viewChanger: false,
};

const Controller: FunctionComponent<ControllerProps> = ({
  filterText,
  filterTagsList,
  viewChanger,
  ...rest
}) => {
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useEffectOnce(() => {
    setIsMounted(true);
  });

  if (!isMounted) return null;

  return ReactDom.createPortal(
    <S.Wrapper {...rest}>
      <S.Container>
        <S.FilterContainer>
          <Filter filterText={filterText} tagsList={filterTagsList} />
        </S.FilterContainer>

        {viewChanger && <ViewChanger />}
      </S.Container>
    </S.Wrapper>,
    document.getElementById('layout-content')
  );
};

Controller.defaultProps = defaultProps;

export default memo(Controller);
